import api from 'api'

export function fetchGigTracking(code) {
  return api.version(3).get(`/gigs/${code.toLowerCase()}/track`).then(resp => resp.data)
}